<template>
  <div class="law-works">
    <banner clazz="law-banner" url="law" hasDivider>
      <template slot="buttons">
        <el-button class="banner-button" round @click="goRegister('fawu-banner-tiyan')">申请体验</el-button>
        <el-button class="banner-button" round @click="this.goConsult">立即咨询</el-button>
      </template>
    </banner>
    <div class="law-section1">
      <div class="clearfix section1-content">
        <img class="fl section1-img" src="../../assets/img/law/law-section1.png" alt="通过采购，助力公司战略执行"/>
        <div class="section1-misc">
          <h1 class="misc-title">通过采购，助力公司战略执行</h1>
          <div class="misc-divider"></div>
          <p class="misc-content">
            法律对于社会生活的影响越来越大，企业作为社会组织的一个部<br/>
            分，自然也不例外。法务作为公司重要一环，对采购流程的可控<br/>
            尤为重要，我们采购过程的法务环节透明化，可控化，助力企业采购合规合法化。
          </p>
          <hover-button text="立即咨询" clazz="consult-button dib" @click.native="goConsult" :duration='0.5'/>
        </div>
      </div>
    </div>
    <div class="law-section2">
      <div class="section2-region">
        <div class="section2-content clearfix">
          <h1 class="section2-title">公司法务面临的五大问题</h1>
          <div class="section2-divider"></div>
          <div>
            <div class="sub-left fl">
              <div class="lists list1">
                <div class="list-img">1</div>
                <h2 class="list-title">法律事务很难融入到采购日常的生产经营活动<br/>
                  也就是俗话说的“法务业务两张皮”
                </h2>
                <p class="list-content">如果不参与到具体的采购业务活动中，法务部只能做<br/>
                  一些争议解决方面的事后救济工作，如果要参与到业<br/>
                  务中去，又很难找到合适的切入点。</p>
              </div>
              <div class="lists list2">
                <div class="list-img">2</div>
                <h1 class="list-title">法律风险防范和业务发展的对立与冲突</h1>
                <p class="list-content">这一点是两者职能上的差别导致的，业务部门要往前<br/>
                  冲，法务部门则要看紧风险的底线。二者之间要找到<br/>
                  平衡点，应该在一个企业内部系统性地解决好法务与<br/>
                  业务的关系，法务一定不能只做业务和企业发展的旁<br/>
                  观者。</p>
              </div>
            </div>
            <div class="sub-center fl">
              <img src="../../assets/img/law/icon@2x.png" alt="企业法律顾问缺乏整体性思维">
            </div>
            <div class="sub-right fl">
              <div class="lists list3">
                <div class="list-img">3</div>
                <h1 class="list-title">企业法律顾问缺乏整体性思维</h1>
                <p class="list-content">有的公司法务人员可以熟练地审阅合同，一年下来审<br/>
                  了成百上千的合同，但是看不出来合同审查问题背后<br/>
                  的规律性的东西，不能从整体上分析相应的管理问题<br/>
                  和业务问题。只有通过大量的统计分析与系统总结，<br/>
                  法律工作才可以变成主动的、整体性的工作，才可能<br/>
                  对企业的经营决策有更大的贡献。</p>
              </div>
              <div class="lists list4">
                <div class="list-img">4</div>
                <h2 class="list-title">法律工作总体上体现被动工作的特点</h2>
                <p class="list-content">传统的法律专业事务工作，由于单纯地从法律专业的<br/>
                  角度去考虑和解决问题，只能等业务或管理有了具体<br/>
                  问题，需要法律解决的时候，才会交给法律顾问处理<br/>
                  所以处于被动的角色。</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="law-section3">
      <div class="section3-content">
        <h1 class="section3-title">甄云采购系统为法务人员提供的价值</h1>
        <div class="section3-divider"></div>
        <div class="section3-main">
          <div class="section3-choose">
            <ul class="section3-ul clearfix">
              <li class="section3-li fl">
                <img class="detail-img" src="../../assets/img/law/law-section3-1.png" alt="降低成本控制并优化采购成本">
                <h2 class="detail-title">降低成本控制并优化采购成本</h2>
                <span class="detail-line"></span>
                <p class="detail">甄云SRM采购系统可帮助您汇总所有内部和第三方纸质<br/>
                  合同数据。凭借一站式采购管理平台，集成的电子签章<br/>
                  等功能，帮您更好的实现部门之间协作。</p>
              </li>
              <li class="section3-li fl">
                <img class="detail-img" src="../../assets/img/law/law-section3-2.png" alt="随时参与，敏捷管理风险">
                <h2 class="detail-title">随时参与，敏捷管理风险</h2>
                <span class="detail-line"></span>
                <p class="detail">甄云SRM系统，提供岗位权限数据管理，既保证数据的<br/>
                  保密性，也让法务人员随时参与采购事项，及时把控采
                  <br/>购风险，保证采购的合规性。</p>
              </li>
              <li class="section3-li fl">
                <img class="detail-img" src="../../assets/img/law/law-section3-3.png" alt="加强和业务的联动性">
                <h2 class="detail-title">加强和业务的联动性</h2>
                <span class="detail-line"></span>
                <p class="detail">便于法务了解采购真实流程，增强法务对采购的理解和<br/>
                  把控，避免法律和业务的隔离，便于公司业务合规合法<br/>
                  化开展。</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import hoverButton from '../common/hoverButton.vue'
import banner from '../common/banner.vue'

export default {
  inject: ['openRegister', 'goConsult'],
  name: 'Law',
  metaInfo () {
    return {
      title: this.$seo.law.title, // set a title
      meta: [{ // set meta
        name: 'keywords',
        content: this.$seo.law.keywords
      },
      {
        name: 'description',
        content: this.$seo.law.description
      }]
    }
  },
  components: {
    hoverButton,
    banner
  },
  data () {
    return {}
  },
  methods: {
    goRegister (code) {
      this.openRegister(false, code)
    }
  }
}
</script>
<style lang="scss">
  @import "../../../static/css/law.scss";
</style>



// WEBPACK FOOTER //
// law.vue?568aabfa